import { render } from "./Desktop.vue?vue&type=template&id=f67df966"
import script from "./Desktop.vue?vue&type=script&lang=js"
export * from "./Desktop.vue?vue&type=script&lang=js"
script.render = render

export default script